import { useQuery } from '@tanstack/react-query';

import { getAuthorizedTeammatesListService } from '@/services/authorizedTeammates';
import { AuthorizedTeammateListQueryParams } from '@/types/authorizedTeammates';
import { convertObjectValuesToString } from '@/utils/responseConvertors';
import { queryKeys } from '@/types/authorizedTeammates';

export const useGetAuthorizedTeammatesList = (
  queryParams: AuthorizedTeammateListQueryParams,
) => {
  const params = new URLSearchParams(
    convertObjectValuesToString(queryParams),
  ).toString();

  const { data, isPending } = useQuery({
    queryKey: [queryKeys.list, params],
    queryFn: () => getAuthorizedTeammatesListService(params),
  });

  return {
    authorizedTeammates: data?.records || [],
    isAuthorizedTeammatesPending: isPending,
    totalRecordsCount: data?.totalRecordCount || 0,
  };
};
